import { Injectable } from '@angular/core';
import IpUserInfo from '../../../../old-crazy-web-frontend/src/app/utils/ip-user-info/ip.user.info.service';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class Ng1IpInfoService {
  private ipUserInfo: IpUserInfo;

  constructor(private configService: ConfigService) {
    this.ipUserInfo = configService.getValue('ipUserInfo');
  }

  getCountry() {
    return this.ipUserInfo.getCountry();
  }
}
